/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerieUserInfo,
    JsonSerieUserInfoFromJSON,
    JsonSerieUserInfoFromJSONTyped,
    JsonSerieUserInfoToJSON,
} from './JsonSerieUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonSerieUserInfo
 */
export interface ApiResultOfJsonSerieUserInfo {
    /**
     * 
     * @type {JsonSerieUserInfo}
     * @memberof ApiResultOfJsonSerieUserInfo
     */
    data?: JsonSerieUserInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonSerieUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUserInfo
     */
    result?: ApiResultOfJsonSerieUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonSerieUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonSerieUserInfoFromJSON(json: any): ApiResultOfJsonSerieUserInfo {
    return ApiResultOfJsonSerieUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonSerieUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonSerieUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonSerieUserInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonSerieUserInfoToJSON(value?: ApiResultOfJsonSerieUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonSerieUserInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

